import React from 'react';

import { KpiCard } from './ui';

const toneMap = {
    amber: 'amber',
    blue: 'navy',
    green: 'navy',
    navy: 'navy'
};

const BiMetric = ({
    className = 'bi-ge-indications-metric',
    icon,
    label,
    subtitle,
    tone = 'amber',
    value
}) => (
    <KpiCard
        className={className}
        helper={subtitle}
        icon={icon}
        label={label}
        tone={toneMap[tone] || tone}
        value={value}
    />
);

export default BiMetric;
